<template>


  
          <button type="button"
              @click='SelectFunction(CarId)'
              class="list-group-item list-group-item-action list-group-item-warning btn-primary d-flex justify-content-between align-items-center">
           {{CarModel}}   {{CarMotor}}    {{CarYear}} {{CarObj.motor.valves}}v - {{CarMotorDescription}}
            <span class=""><i class="fas fa-angle-right"></i></span>
          </button>





</template>

<script>
    export default {
        props: {
            CarId: {
                type: Number,
            },
            CarObj: {
                type: Object,
            },
            CarImg: {
                type: String,
            },
            CarModel: {
                type: String,
            },
            CarMotor: {
                type: String,
            },
            CarYear: {
                type: [String, Number],
            },
            CarMotorDescription: {
                type: String,
            },
            SelectFunction:{
                type:Function
            }
        },
    }
</script>

<style lang="css" scoped>
/* HIDE RADIO */
[type=radio] { 
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* IMAGE STYLES */
[type=radio] + img {
  cursor: pointer;
}

/* CHECKED STYLES */
[type=radio]:checked + img  {
  outline: 2px solid #f00;
}

.img-sm {
    width: 150px;
    height: 80px;
}

.img-lg {
    width: 100%;
    height: 5rem;
}
.img-xs, .img-sm, .img-md, .img-lg {
    -o-object-fit:contain;
    object-fit: contain;
    flex-shrink: 0;
    flex-grow: 0;
}
img {
    vertical-align: middle;
    border-style: none;
}

.btn-primary {
    color: var(--main-red-black);
    background-color: var(--main-white);
    border-color: var(--main-red-black);
}

.btn-outline-primary {
    color: var(--main-red-black);
    border-color: var(--main-red-black);
}

.title-list{
    font-size: 1rem;
  font-weight:900;
  padding-top:1%;
  font-family: 'Roboto',sans-serif;
  color:var(--main-red-black);
  text-transform:uppercase;
}

.btn-primary:focus,.btn-primary:active {
   outline: none !important;
   box-shadow: none;
}


.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open>.dropdown-toggle.btn-primary {
    color: #fff;
    background-color: var(--main-red-black);
    /*set the color you want here*/
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: var(--main-red-black);
    border-color: var(--main-red-black);
}

.list-group-item-warning {
    color: var(--main-red-black);
    background-color: var(--main-white);
    border: 0.019rem solid var(--main-red-light);
}
.list-group-item.active {
    z-index: 2;
    color: var(--main-white);
    background-color: var(--main-red-black);
    border-color: var(--main-red-black);
    border-style: solid;
}
</style>